const state = {
    dataTableFooterProps: {
        'items-per-page-options': [10, 20, 30, 40, 50, 100],
    },
};

const getters = {
    dataTableFooterProps: state => {
        return state.dataTableFooterProps;
    },
};

const actions = {};

const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations,
};